import React from "react";
import {NavLink, useHistory} from "react-router-dom";
import { Typography, Paper } from "@material-ui/core";
import { SendOutlined } from "@material-ui/icons";
import { useTranslation } from "../langs/useTranslation";
import useStyles from "../styles/loginStyle";
import StyledSubmitBtn from "@/components/commons/StyledSubmitBtn";

const LoginWithNewPwd = () => {
  const classes = useStyles();
  const { t } = useTranslation("login");
  let history = useHistory();

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <SendOutlined color="primary" />
        <Typography
          className={classes.loginAgainText}
          variant="h6"
          align="center"
        >
          {t("loginAgain.title")}
        </Typography>
        <Typography className={classes.loginAgainTitle} align="center">
          {t("loginAgain.newPwdSent")}
          <br />
          {t("loginAgain.loginWithNewPwd")}
        </Typography>
        {/*<LoginForm />*/}
        <StyledSubmitBtn
          fullWidth
          size="large"
          btnColor="primary"
          variant="contained"
          btnText={t("forgotPwd.confirmBtn")}
          onClick={()=>{
            history.push('/login')
          }}
        />
        <NavLink to="/forgotPassword" className={classes.linkText}>
          {t("loginAgain.pwdSendAgainMsg")}
        </NavLink>
      </Paper>
    </div>
  );
};

export default LoginWithNewPwd;
